// extracted by mini-css-extract-plugin
export default {"formDivider":"PaymentForm_formDivider__hBgdv","inputLabel":"PaymentForm_inputLabel__gFGyC","cardsWrapper":"PaymentForm_cardsWrapper__DMEle"};